export default {
    methods: {
        report(error) {
            if (
                process.env.NODE_ENV == 'production' ||
                process.env.MIX_BUGSNAG_DEBUG
            ) {
                if (error.hasOwnProperty('config')) {
                    if (error.hasOwnProperty('request')) {
                        this.$bugsnag.addMetadata('request', {
                            headers: _.get(error.config, 'headers'),
                            data: _.get(error.config, 'data'),
                            method: _.get(error.config, 'method'),
                            'request url': _.get(error.config, 'url'),
                        })
                    }

                    if (error.hasOwnProperty('response')) {
                        this.$bugsnag.addMetadata('response', {
                            headers: _.get(error.response, 'headers'),
                            data: _.get(error.response, 'data'),
                            status: _.get(error.response, 'status'),
                        })
                    }
                }

                this.$bugsnag.notify(error)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/mixins/errors.js